import React from "react";
import DashboardPageContainer from "../components/dashboard/DashboardPageContainer";

const DashboardPage = () => {
	return <div><DashboardPageContainer /></div>;
};	

export default DashboardPage